import PropTypes from 'prop-types';

CompanyLink.propTypes = {
    company: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
};

export default function CompanyLink({ company }) {
    return <a href={`/app/observer/company/${company.id}`}>{company.name}</a>;
}
